export * from '../nivel/nivel.component'
export * from '../nivel/list/nivelList.component'
export * from '../nivel/detail/nivelDetail.component'
export * from '../nivel/create/nivelCreate.component'
export * from '../nivel/edit/nivelEdit.component'
export * from '../nivel/search/nivelSearch.component'
export * from '../nivel/nivel.service'